import { ScopesListClass } from '../../components/descope-scopes-list/ScopesListClass';
import theme, { vars as inputVars } from './inputWrapper';

export const vars = ScopesListClass.cssVarList;

const scopesList = {
  [vars.requiredInputBorderColor]: theme._disabled[inputVars.borderColor],
  [vars.requiredInputValueTextColor]: theme._disabled[inputVars.valueTextColor],
  [vars.hostWidth]: '280px',
  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default scopesList;
